<template>
    <v-col cols="12" class="About mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                 <v-row  >
                        <v-col>
                             <h2 class="font-weight-medium text-center title-reports my-6">Términos y condiciones</h2>
                        </v-col>
                       
                    </v-row>
                    <v-row>
                        <v-col lg="10" cols="12" class="px-12 mx-auto">
                            <p class="font-weight-light">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis eros tellus, hendrerit vitae semper ac, consequat nec ligula. Proin odio turpis, vestibulum id mollis sed, vestibulum a leo. Nulla in eros tempus, varius quam vitae, accumsan velit. Sed nec ante lorem. Curabitur eu magna in arcu vestibulum volutpat at at tortor. Donec iaculis purus eget lacus congue tincidunt. Praesent quis tempus nisl, sit amet sagittis dui. Vivamus iaculis nulla massa, sit amet volutpat odio pretium at.
                            </p>
                            <p class="font-weight-light">
                                Vestibulum ut lectus eget augue luctus posuere. Etiam turpis magna, volutpat in enim vel, ullamcorper commodo sapien. Vivamus feugiat quis risus ac accumsan. Vivamus a urna euismod, vehicula mi in, tempus enim. Pellentesque eu purus sit amet nulla mattis mollis sit amet eu felis. Morbi ac erat at tellus sollicitudin venenatis vel in nulla. Fusce ultricies ullamcorper laoreet. Morbi pharetra ut nulla id ornare. Etiam quis suscipit diam. Quisque vitae nibh augue. Phasellus sed commodo ex, sodales imperdiet enim. Etiam molestie felis lectus, id posuere elit sagittis nec. Mauris magna enim, rutrum nec pellentesque quis, facilisis vitae mauris. Suspendisse nec posuere justo.
                            </p>
                            <p class="font-weight-light">
                                Pellentesque dolor sapien, gravida id ultrices non, fringilla sit amet velit. Phasellus non neque luctus, tristique enim sed, consequat velit. Donec mi massa, luctus sollicitudin rutrum eget, sagittis eget lorem. Nulla et velit magna. Nunc et diam nulla. Donec a lorem ac justo vestibulum pharetra. Phasellus feugiat consectetur augue at semper. Curabitur sed malesuada diam, in porta nisi. Nulla facilisi. Pellentesque ultricies nulla ullamcorper, tincidunt libero ut, viverra nibh. Nullam non tincidunt mi. In ac libero luctus, varius augue et, consequat eros. Aliquam erat volutpat. Proin vestibulum nisl mauris, at sodales tellus eleifend eu. Donec scelerisque mi eget risus mollis, non interdum lectus blandit. Sed feugiat at sapien nec dapibus.
                            </p>
                            <p class="font-weight-light">
                                Suspendisse condimentum velit a porta euismod. Nulla ut ultricies erat. Ut molestie nibh et venenatis gravida. Sed placerat diam non egestas dictum. Nunc faucibus at nisl id venenatis. Cras id sodales purus. Ut nec vestibulum purus, ac interdum justo. Etiam eu elit at libero efficitur pretium quis at mauris. Integer libero mauris, maximus sed facilisis et, ornare ac nisl. Nulla congue aliquet leo, et lacinia nunc ultrices sit amet. Maecenas vulputate turpis ut dictum dapibus. Fusce fringilla mauris libero. Aenean sit amet posuere lorem. Pellentesque non ex quis mauris efficitur tincidunt eu quis nunc. Nam ac tellus malesuada, semper orci ut, laoreet neque. Mauris interdum et ex quis scelerisque.
                            </p>
                            <p class="font-weight-light">
                                Quisque accumsan, elit vitae tempor lobortis, dui odio venenatis eros, id elementum leo urna eu orci. Phasellus et scelerisque neque, eget efficitur nunc. Suspendisse sit amet mauris et mauris mollis porta. Praesent faucibus, felis sit amet pellentesque fringilla, lectus lacus dapibus dolor, a hendrerit nulla nisl vitae velit. Donec ullamcorper maximus arcu quis laoreet. Sed massa lectus, accumsan non lacinia vitae, consectetur sit amet nulla. Proin quis metus risus. Sed vitae diam maximus, tincidunt est sit amet, vulputate mi. Mauris eu efficitur neque, vel pellentesque massa. Aliquam sagittis viverra leo vitae tempus. Aenean in ullamcorper tortor. Curabitur placerat dolor in fringilla porttitor. Curabitur lacinia suscipit leo, id malesuada mi rutrum nec.
                            </p>
                        </v-col>
                    </v-row>

                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>
<style lang="scss">

.v-expansion-panel{
    background: #F2F2F2 !important;
    border-radius: 4px;
}
.v-expansion-panel-content{
    border: 1px solid #F2F2F2;
    background-color: #ffffff !important;
    }


</style>
<script>
    export default {
        name: 'About',
        created: function () {
            //this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>